import { useContext, useMemo } from "react";
import { useLocalization } from "@fluent/react";
import type Account from "byzantine/src/Account";
import AccountContext from "../../contexts/AccountContext";
import { FILTER_CONFIG, FilterChips, FilterType } from "./filterConfig";
import { MultiSelectFilter } from "./common";

const AccountFilter = ({
  filters,
  isActive,
  handleSetActive,
  handleSetFilter,
  handleToggleFilter,
}: FilterType) => {
  const { l10n } = useLocalization();
  const label = l10n.getString(FILTER_CONFIG[FilterChips.ACCOUNT].labelKey);
  const { accounts } = useContext(AccountContext);
  const validAccounts = accounts.filter((account: Account) =>
    account.isValidAchTransferSource()
  );
  const accountsOptions = useMemo(
    () =>
      validAccounts.map((account: Account) => ({
          label: `${account.name} ${account.getMaskedNumber()}`,
          key: account.id,
        })),
    [validAccounts]
  );

  return (
    <MultiSelectFilter
      filters={filters}
      isActive={isActive}
      handleSetActive={handleSetActive}
      handleSetFilter={handleSetFilter}
      handleToggleFilter={handleToggleFilter}
      label={label}
      filterOptions={accountsOptions}
      filterName={FilterChips.ACCOUNT}
    />
  );
};

export default AccountFilter;
